import PropTypes from 'prop-types'
import { useEffect, useState } from 'react';
import { loadImagePromise, ratio } from '../../helpers/UtilFunctions';
import Text from '../native/Text';

const CardInformationComponent = (props: any) => {


    const [image, setImage] = useState("https://www.sinrumbofijo.com/wp-content/uploads/2016/05/default-placeholder.png");
    const [size, setSize] = useState(props.size);

    useEffect(() => {

        const verifyexists = async () => {
            let img: any = await loadImagePromise(props.bgimg);
            if (img) {

                if (ratio(img.width, img.height) > 1.5) {
                    setSize(2);
                }
                setImage(img.src);
            }
        };

        verifyexists();

    }, [props]);

    const calcSize = () => (size === 1 || size === 3 ? ('w-3/6') : ('w-full'));
    const calcHeight = () => (size === 1 ? 'h-48' : (size === 3 ? 'h-48' : 'h-48'));

    return (
        <div className={'relative group container p-2 ' + calcSize()} >
            <div className={'rounded-lg ' + calcHeight()}
                onClick={() => { props.click(props) }}
                style={{ 'backgroundImage': `url(${image})`, 'backgroundPosition': 'center', 'backgroundSize': 'cover' }}>

            </div>
            <div className='cursor-pointer'>
                <span onClick={() => { props.click(props) }}><Text size={16}>{props.name}</Text></span>
            </div>

        </div>
    )
}

CardInformationComponent.propTypes = {
    name: PropTypes.string,
    bgimg: PropTypes.string,
    size: PropTypes.number,
    id: PropTypes.string,
    click: PropTypes.func
}

export default CardInformationComponent;
